// Delivery Address Store
import { getField, updateField } from 'vuex-map-fields'

const state = {
  deliveryAddress: {},
  deliveryAddressActive: false,
  pending: false,
}

const getters = {
  isPending: ({ pending }) => pending,
  isDeliveryAddressActive: ({ deliveryAddressActive }) => deliveryAddressActive,
  getField,
}

const actions = {
  updateAddress({ commit }, payload) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items.createItem('carts.mine.delivery_address', payload).then(({ data }) => {
        if (data && data.redirect) {
          window.location.href = data.redirect
        } else {
          commit('LAST_UPDATE_ADDRESS')
          commit('SET_PENDING')
          resolve()
        }
      })
    })
  },
  updateDeliveryAddressActive({ commit }) {
    return new Promise(resolve => {
      commit('SET_PENDING')
      this.api.items
        .createItem('carts.mine.delivery_address', {
          ...state.deliveryAddress,
          separate_delivery_address: !state.deliveryAddressActive,
        })
        .then(_ => {
          commit('UPDATE_DELIVERY_ADDRESS_ACTIVE')
          commit('SET_PENDING')
          resolve()
        })
    })
  },
}

const mutations = {
  SET_PENDING: state => {
    state.pending = !state.pending
  },
  SET_DELIVERY_ADDRESS: (state, payload) => {
    state.deliveryAddress = payload
  },
  INIT_DELIVERY_ADDRESS: (state, payload) => {
    state.deliveryAddress = payload.delivery_address
    if (payload.cart.separate_delivery_address) {
      state.deliveryAddressActive = payload.cart.separate_delivery_address
    }
  },
  UPDATE_DELIVERY_ADDRESS_ACTIVE: state => {
    state.deliveryAddressActive = !state.deliveryAddressActive
  },
  updateField,
  LAST_UPDATE_ADDRESS: _ => {
    return true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
